<template>
  <DataTableDemo />
</template>

<script>
import DataTableDemo from "../components/TableUser/DataTableDemo";

export default {
  name: "User",
  components: {
    DataTableDemo,
  },
};
</script>

<style scoped>
</style>
